// Copyright (c) 2016 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../actions-list';
import {getProductClaims} from '../../shared/repositories';

export const updateClaims = pin =>
    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const payload = await getProductClaims(pin);

            dispatch({
                payload,
                property: 'claims',
                type: actions.UPDATE_PRODUCT_CLAIMS_SUCCESS
            });

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/product/details/action-creators/claims.js